let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fF0Is")).then(() => parcelRequire('jdOHc'));